import { TrendingUp, Clock, Building2, Euro } from "lucide-react";
const SEOContent = () => {
  return <section className="section-padding bg-background" id="ratgeber" aria-label="Ratgeber Plasmaspenden">
      <div className="container container-narrow">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-5 font-display">
            <span className="text-foreground">Ratgeber: </span>
            <span className="text-gradient">Plasmaspenden in Deutschland</span>
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto text-lg">
            Alles Wichtige rund um das Thema Blutplasma spenden kompakt zusammengefasst
          </p>
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
          <div className="card-modern p-5 text-center">
            <Euro className="w-8 h-8 text-bonus mx-auto mb-3" />
            <p className="text-2xl md:text-3xl font-bold text-foreground mb-1">150€</p>
            <p className="text-xs text-muted-foreground">Anmeldebonus möglich</p>
          </div>
          <div className="card-modern p-5 text-center">
            <TrendingUp className="w-8 h-8 text-accent mx-auto mb-3" />
            <p className="text-2xl md:text-3xl font-bold text-foreground mb-1">60x</p>
            <p className="text-xs text-muted-foreground">maximal, individuelle Eignung vorausgesetzt</p>
          </div>
          <div className="card-modern p-5 text-center">
            <Building2 className="w-8 h-8 text-primary mx-auto mb-3" />
            <p className="text-2xl md:text-3xl font-bold text-foreground mb-1">30+</p>
            <p className="text-xs text-muted-foreground">Standorte bundesweit</p>
          </div>
           <div className="card-modern p-5 text-center">
            <Clock className="w-8 h-8 text-primary mx-auto mb-3" />
            <p className="text-2xl md:text-3xl font-bold text-foreground mb-1">30–55 Min</p>
            <p className="text-xs text-muted-foreground">reine Spende, je nach Anbieter</p>
          </div>
        </div>

        {/* SEO Content Sections */}
        <div className="space-y-8">
          <article className="card-modern p-6 md:p-8">
            <h3 className="text-xl font-bold text-foreground mb-4 font-display">
              Warum Plasmaspenden in Deutschland immer beliebter wird
            </h3>
            <div className="prose prose-invert max-w-none">
              <p className="text-muted-foreground leading-relaxed mb-4">
                Plasmaspenden gewinnt in Deutschland zunehmend an Bedeutung. Immer mehr Menschen entdecken die Möglichkeit, 
                durch regelmäßige Plasmaspenden Leben zu retten und gleichzeitig eine attraktive Aufwandsentschädigung 
                zu erhalten. Aus Blutplasma werden Arzneimittel hergestellt, darunter Immunglobuline zur Behandlung 
                primärer Immundefekte und Präparate für Blutgerinnungsstörungen. Diese Medikamente sind für die 
                Versorgung betroffener Patientinnen und Patienten wichtig.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Bei der Plasmaspende wird Plasma gewonnen und die übrigen Blutbestandteile werden zurückgeführt. Dadurch 
                sind kürzere Abstände als bei der Vollblutspende möglich. Bis zu 60 Plasmaspenden innerhalb von zwölf 
                Monaten können möglich sein; wie häufig eine Person tatsächlich spenden kann, hängt unter anderem von 
                der individuellen Regeneration der Proteine und der ärztlichen Beurteilung ab. Bei zusätzlicher 
                Vollblutspende gelten andere Abstände. <a href="https://www.blutspenden.de/faq" target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:text-foreground">Quelle: BIÖG</a>.
              </p>
            </div>
          </article>

          <article className="card-modern p-6 md:p-8">
            <h3 className="text-xl font-bold text-foreground mb-4 font-display">
              Plasmaspende Verdienst: So viel Geld können Sie erhalten
            </h3>
            <div className="prose prose-invert max-w-none">
              <p className="text-muted-foreground leading-relaxed mb-4">Die reguläre Aufwandsentschädigung für eine Plasmaspende liegt in Deutschland bei etwa 30 Euro pro Termin. Durch Sonderaktionen und Bonusprogramme ist jedoch deutlich mehr möglich! Bei regelmäßiger Teilnahme können Sie mit einem monatlichen Zusatzverdienst von 200 bis 300 Euro rechnen.</p>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Besonders lukrativ ist der Anmeldebonus für Neuspender. Anbieter wie CSL Plasma und Plasma Service Europe 
                bieten attraktive Bonusprogramme. Wenn Sie bei der Erstanmeldung eine Spendernummer angeben, können 
                Sie von einem zusätzlichen Anmeldebonus profitieren.
              </p>
              <p className="text-muted-foreground leading-relaxed">Wichtig: Die Aufwandsentschädigung gilt als steuerfreier Nebenverdienst, solange Sie die jährliche Freigrenze nicht überschreiten.</p>
            </div>
          </article>

          <article className="card-modern p-6 md:p-8">
            <h3 className="text-xl font-bold text-foreground mb-4 font-display">
              Plasmazentren in Deutschland: CSL Plasma und Plasma Service Europe
            </h3>
            <div className="prose prose-invert max-w-none">
              <p className="text-muted-foreground leading-relaxed mb-4">
                In Deutschland gibt es zwei große Anbieter für Plasmaspenden: CSL Plasma und Plasma Service Europe. 
                Beide Unternehmen betreiben moderne Plasmazentren in zahlreichen deutschen Städten und bieten 
                professionelle medizinische Betreuung während der gesamten Spende.
              </p>
              <p className="text-muted-foreground leading-relaxed mb-4">
                <strong className="text-foreground">CSL Plasma</strong> gehört zum weltweit führenden Biotechnologieunternehmen 
                CSL Behring und betreibt Plasmazentren in mehreren deutschen Städten, darunter auch Wiesbaden. Die Zentren befinden sich unter anderem in 
                Berlin, Hamburg (Hamburger Meile), Leipzig (Höfe am Brühl), Frankfurt, Köln, Bremen, Nürnberg, Braunschweig und vielen weiteren Städten. CSL Plasma ist bekannt für seine 
                modernen Einrichtungen und das attraktive Vergütungssystem.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                <strong className="text-foreground">Plasma Service Europe</strong> ist ein weiterer führender Anbieter mit 
                14 Plasmazentren in 13 Städten, darunter zwei Zentren in Köln. Weitere Standorte befinden sich unter anderem in Dortmund, Hannover, Magdeburg und Rostock. Das Unternehmen 
                legt großen Wert auf eine angenehme Atmosphäre und bietet ebenfalls attraktive Bonusprogramme für 
                neue Spender an.
              </p>
            </div>
          </article>

          <article className="card-modern p-6 md:p-8">
            <h3 className="text-xl font-bold text-foreground mb-4 font-display">
              Plasmaspende vs. Blutspende: Die wichtigsten Unterschiede
            </h3>
            <div className="prose prose-invert max-w-none">
              <p className="text-muted-foreground leading-relaxed mb-4">
                Viele Menschen fragen sich, worin der Unterschied zwischen Plasmaspende und Blutspende besteht. 
                Bei der klassischen Blutspende wird Vollblut entnommen, das alle Bestandteile enthält. Bei der 
                Plasmaspende hingegen wird das Blut durch ein spezielles Gerät geleitet, das nur das flüssige 
                Plasma abtrennt und die festen Bestandteile wie rote Blutkörperchen sofort wieder zurückführt.
              </p>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Dieser Unterschied ermöglicht kürzere Spendeabstände als bei einer Vollblutspende. Innerhalb von zwölf 
                Monaten sind bis zu 60 Plasmaspenden möglich. Die tatsächliche Häufigkeit richtet sich nach der 
                individuellen Regeneration der Proteine, weiteren Spenden und der medizinischen Beurteilung vor Ort. <a href="https://www.blutspenden.de/faq" target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:text-foreground">Quelle: BIÖG</a>.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Die eigentliche Plasmaspende dauert je nach Anbieter etwa 30 bis 55 Minuten. Für Anmeldung, ärztliche Untersuchung und Erholung kommt beim regulären Besuch zusätzliche Zeit hinzu. Beim Erstbesuch sind Aufnahme, Untersuchung und Blutprobe einzuplanen; je nach Anbieter liegen Laborprüfung und erste Spende an unterschiedlichen Tagen.
              </p>
            </div>
          </article>

          <article className="card-modern p-6 md:p-8">
            <h3 className="text-xl font-bold text-foreground mb-4 font-display">
              Tipps für Ihre erste Plasmaspende
            </h3>
            <div className="prose prose-invert max-w-none">
              <ul className="text-muted-foreground space-y-3">
                <li className="flex items-start gap-3">
                  <span className="text-accent font-bold">✓</span>
                  <span>Trinken Sie am Tag der Spende mindestens 2 Liter Wasser oder ungesüßten Tee</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-accent font-bold">✓</span>
                  <span>Essen Sie vor der Spende eine leichte, fettarme Mahlzeit</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-accent font-bold">✓</span>
                  <span>Bringen Sie einen gültigen Personalausweis oder Reisepass mit</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-accent font-bold">✓</span>
                  <span>Planen Sie beim Erstbesuch zusätzliche Zeit für Aufnahme, Untersuchung und Blutprobe ein; die erste Spende kann an einem späteren Termin stattfinden</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-accent font-bold">✓</span>
                  <span>Vergessen Sie nicht, bei der Anmeldung Ihre Spendernummer für den Bonus anzugeben</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-accent font-bold">✓</span>
                  <span>Vermeiden Sie am Tag vor der Spende fettreiche Speisen und Alkohol</span>
                </li>
              </ul>
            </div>
          </article>
        </div>
      </div>
    </section>;
};
export default SEOContent;
